import React from 'react';
import { useTranslation } from 'react-i18next';
import { Placeholder } from '@/components/ui';

// The store links do not exist yet — neither app has been published. They render
// as disabled buttons rather than being hidden, because "coming to the stores" is
// itself information a visitor wants, and a hidden button is one nobody remembers
// to wire up later. Swap the <button>s for <a href> when the listings are live.
const STORE_LINKS_LIVE = false;

export const Hero: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className="hero">
            <div className="wrap hero__grid">
                <div>
                    <h1 className="hero__title">{t('web.hero.title')}</h1>
                    <p className="hero__sub">{t('web.hero.sub')}</p>

                    <div className="hero__cta">
                        <button className="btn btn--lg" type="button" disabled={!STORE_LINKS_LIVE}>
                            {t('web.hero.ctaAndroid')}
                        </button>
                        <button className="btn btn--lg btn--ghost" type="button" disabled={!STORE_LINKS_LIVE}>
                            {t('web.hero.ctaIos')}
                        </button>
                    </div>

                    <p className="hero__note">
                        {STORE_LINKS_LIVE ? t('web.hero.noteFree') : t('web.hero.noteComingSoon')}
                    </p>
                </div>

                <Placeholder
                    shape="phone"
                    label={t('web.placeholder.heroShot')}
                    hint={t('web.placeholder.hint')}
                />
            </div>
        </section>
    );
};
